import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <ContactSection />
        <TopicsSection />
        <FaqSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <CarouselSection />
        <IndexSection />
        <AboutSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}